interface IAppContext {
  AppTitle: string;
}
type AppContext = IAppContext;

const appContext: AppContext = {
  AppTitle: 'ICE Admin',
};
interface IAPIDefinition {
  key: string;
  Uri: string;
}
const defineApi = (key: string, uri: string) => {
  apiList.set(key, { key: key, Uri: uri });
};
const apiList = new Map<string, IAPIDefinition>();
//TODO: Add for each item

const urlPath = process.env.REACT_APP_ICE_ADMIN_URL || '';
const reIndexerPath = process.env.REACT_APP_REINDEXER || '';

defineApi('DeleteUrl', `${urlPath}/routes`);
defineApi('UrlPatterns', `${urlPath}/routes`);
defineApi('CustomerProduct', `${urlPath}/customerproduct`);
defineApi('DeleteRoute', `${urlPath}/routes`);
defineApi('DeleteVersion', `${urlPath}/versions`);
defineApi('Plugins', `${urlPath}/plugins`);
defineApi('Plugin', `${urlPath}/plugins`);
defineApi('FeatureTypes', `${urlPath}/featureType`);
defineApi('Customers', `${urlPath}/customers`);
defineApi('Customer', `${urlPath}/customers`);
defineApi('Products', `${urlPath}/products`);
defineApi('ProductsList', `${urlPath}/products`);
defineApi('Product', `${urlPath}/products/details`);
defineApi('ProductDetails', `${urlPath}/products/details`);
defineApi('DeleteProduct', `${urlPath}/products`);
defineApi('ProductCustomer', `${urlPath}/product/customers`);
defineApi('ProductFeature', `${urlPath}/product/features`);
defineApi('ProductConnector', `${urlPath}/product/connectors`);
defineApi('ProductIntegration', `${urlPath}/product/integrations`);
defineApi('ProductPlugin', `${urlPath}/product/plugins`);
defineApi('DeleteCustomer', `${urlPath}/customers`);
defineApi('DeletePlugin', `${urlPath}/plugins`);
defineApi('ProductsEnabled', `${urlPath}/products/enabled`);
defineApi('CustomersEnabled', `${urlPath}/customers/enabled`);
defineApi('PluginEnabled', `${urlPath}/plugins/enabled`);
defineApi('ConnectorsEnabled', `${urlPath}/connectors/enabled`);
defineApi('FeatureEnabled', `${urlPath}/features/enabled`);
defineApi('CampaignsEnabled', `${urlPath}/campaigns/enabled`);
defineApi('IntegrationsEnabled', `${urlPath}/integrations/enabled`);
defineApi('DeleteFeature', `${urlPath}/features`);
defineApi('DeleteConnector', `${urlPath}/connectors`);
defineApi('DeleteIntegration', `${urlPath}/integrations`);
defineApi('Connectors', `${urlPath}/connectors`);
defineApi('Connector', `${urlPath}/connectors`);
defineApi('Integrations', `${urlPath}/integrations`);
defineApi('Integration', `${urlPath}/integrations`);
defineApi('Features', `${urlPath}/features`);
defineApi('FeaturesEnabled', `${urlPath}/features`);
defineApi('Feature', `${urlPath}/features`);
defineApi('Environments', `${urlPath}/environment`);
defineApi('Versions', `${urlPath}/versions`);
defineApi('Routes', `${urlPath}/routes`);
defineApi('SearchWeight', `${urlPath}/searchweights`);
defineApi('CourseLookup', `${urlPath}/courseLookUpList`);
defineApi('CardType', `${urlPath}/cardTypeList`);
defineApi('IconType', `${urlPath}/iconTypeList`);
defineApi('Command', `${urlPath}/commandList`);
defineApi('ContentType', `${urlPath}/contentTypeList`);
defineApi('contentReIndexUrl', `${urlPath}/contentReIndexUrl`);
defineApi('ReIndexContentList', `${urlPath}/contentReIndexUrlList`);
defineApi('dynamicUrlGenerator', `${urlPath}/dynamicUrlGenerator`);
defineApi('contentReIndexProduct', `${urlPath}/contentReIndexProduct`);
defineApi('contentReIndexProductList', `${urlPath}/contentReIndexProductList`);
defineApi(
  'productConfigurationList',
  `${urlPath}/products/{productId}/configs`
);
defineApi('productCustomerList', `${urlPath}/products/{productId}/customers`);
defineApi('productConfiguration', `${urlPath}/productConfiguration`);
defineApi(
  'productConfigurationDetails',
  `${urlPath}/products/{productId}/configs/{configId}`
);
defineApi(
  'productConfiguration/update',
  `${urlPath}/productConfiguration/update`
);
defineApi('languageString', `${urlPath}/languageString`);
defineApi('language', `${urlPath}/language`);
defineApi('Environment', `${urlPath}/environment`);
defineApi('keys', `${urlPath}/keys`);
defineApi('Featuresearch', `${urlPath}/features/search`);
defineApi('Integrationsearch', `${urlPath}/integrations/search`);
defineApi('Connectorsearch', `${urlPath}/connectors/search`);
defineApi('Pluginsearch', `${urlPath}/plugins/search`);
defineApi('Customersearch', `${urlPath}/customers/search`);
defineApi('Productsearch', `${urlPath}/products/search`);
defineApi('CampaignsSearch', `${urlPath}/campaign/search`);
defineApi('IllustrationIcons', `${urlPath}/illustrationIcons`);
defineApi('FeaturesReorder', `${urlPath}/features/reorder`);
defineApi('ProductCustomers', `${urlPath}/products/{productId}/customers`);
defineApi('metaDataIcons', `${urlPath}/metaDataIcons`);
defineApi('metaDataURL', `${urlPath}/metaDataList`);
defineApi('Campaigns', `${urlPath}/campaign`);
defineApi('CampaignNotifications', `${urlPath}/campaign`);
defineApi('Notifications', `${urlPath}/notification`);
defineApi('customcard', `${urlPath}/customcard`);
defineApi('Reindexer', `${reIndexerPath}`);
defineApi('auth', `${urlPath}/auth/api-key`);
defineApi('settings', `${urlPath}/users/add-access`);
defineApi('allAssociatedCustomers', `${urlPath}/products/customer-ids`);
// ---------- Settings RBAC APIs starts ------------
defineApi('rbacUserRoles', `${urlPath}/roles`);
defineApi('rbacGrantAccess', `${urlPath}/grant/{email}/access`);
defineApi('rbacRevokeAccess', `${urlPath}/revoke/{email}/access`);
defineApi('rbacUserEmail', `${urlPath}/users/{email}`);
// ---------- Settings RBAC APIs ends ------------

const getApiDefinition = (key: string): IAPIDefinition => {
  return (
    apiList.get(key) || {
      key: key,
      Uri: `${urlPath}`,
    }
  );
};
const routeDisplayTable = new Map<string, string>();
routeDisplayTable.set('Addintegration', 'Add Integration');
routeDisplayTable.set('addplugin', 'Add Plugin');
routeDisplayTable.set('addcustomer', 'Add Customer');
routeDisplayTable.set('updatecustomer', 'Update Customer');
routeDisplayTable.set('subfeature1', 'Sub Feature 1');
routeDisplayTable.set('contentindex', 'Content Re-Index');
routeDisplayTable.set('localizationTable', 'Localization Table');
routeDisplayTable.set('keyManager', 'Key Manager');
routeDisplayTable.set(
  'metadatagenerator',
  'AEM Documentation Metadata Generator'
);
export { appContext, routeDisplayTable, getApiDefinition };
